import { canAdminBypassGradingWindow } from "../isUser";

/**
 * Whether the current user may edit an unreleased EPR (comments, ratings, roster, shares, etc.).
 * Teachers require an open GRADING_PROFILE window; admins may edit outside the window.
 * Released EPRs are read-only for everyone until the release is cancelled.
 *
 * @param {Object} params
 * @param {boolean} params.isActiveWindow - GRADING_PROFILE window open for this profile's time period
 * @param {string} params.status - Grading profile release status ("NOT_RELEASED" | "READY_FOR_RELEASE")
 * @param {Object} params.userDetails - Logged-in user details (roleDtos)
 * @returns {boolean}
 */
const isEprEditable = ({ isActiveWindow, status, userDetails }) =>
    status === "NOT_RELEASED" && (Boolean(isActiveWindow) || canAdminBypassGradingWindow(userDetails));

export default isEprEditable;
